import type { WavespeedModelConfig } from '../../types';
import { resolveImageSize, clampTo } from '../../../tools';

export const wanConfigs: Record<string, WavespeedModelConfig> = {
    'alibaba/wan-2.7/text-to-image-pro': {
        // https://wavespeed.ai/models/alibaba/wan-2.7/text-to-image-pro
        apiPath: '/alibaba/wan-2.7/text-to-image-pro',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions} = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), `wan-2.7-${clampTo((image_resolution || '1K').toUpperCase(), ['1K', '2K', '4K'] as const, '1K')}`,
                ),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 可选参数
                thinking_mode: typeof providerOptions?.thinking_mode === 'boolean' ? providerOptions.thinking_mode : false,
            };
        },
    },
    'alibaba/wan-2.7/image-edit-pro': {
        // https://wavespeed.ai/models/alibaba/wan-2.7/image-edit-pro
        apiPath: '/alibaba/wan-2.7/image-edit-pro',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, seed, providerOptions} = params;
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), `wan-2.7-${clampTo((image_resolution || '1K').toUpperCase(), ['1K', '2K', '4K'] as const, '1K')}`,
                ),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: image_urls.slice(0, 9),
            };
        },
    },
    'alibaba/wan-2.7/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/alibaba/wan-2.7/text-to-image
        apiPath: '/alibaba/wan-2.7/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                size: resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), `wan-2.7-${clampTo((image_resolution || '1K').toUpperCase(), ['1K', '2K'] as const, '1K')}`,
                ),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 可选参数
                thinking_mode: typeof providerOptions?.thinking_mode === 'boolean' ? providerOptions.thinking_mode : true,
            };
        },
    },
    'alibaba/wan-2.7/image-edit': {
        // https://wavespeed.ai/models/alibaba/wan-2.7/image-edit
        apiPath: '/alibaba/wan-2.7/image-edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions} = params;
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? undefined : resolveImageSize(
                    clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), `wan-2.7-${clampTo((image_resolution || '1K').toUpperCase(), ['1K', '2K'] as const, '1K')}`,
                ),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 图片 URL
                images: image_urls.slice(0, 9),
            };
        },
    },
};